//types
import {IOrganizationTicketsTiers} from '@/utils/types';

export const getTiersTitle = (ticketsTiers: IOrganizationTicketsTiers[], tableInfoId: number) =>
	ticketsTiers.find((tier) => tier.id === tableInfoId)?.name;
